import { redirect } from '@tanstack/react-router';
import { useAuthStore } from '../store/auth.store';
import { isTokenExpired } from './session';

export function requireOperator() {
  const { sessionToken } = useAuthStore.getState();
  if (isTokenExpired(sessionToken)) throw redirect({ to: '/login' });
}

export function requireAdmin() {
  requireOperator();
  if (useAuthStore.getState().role !== 'admin') throw redirect({ to: '/' });
}
